import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUpdateOrderMutation } from 'api/generated/graphql';
import { parseOrderEntity, useError, useNotifyMessages } from 'api/helpers';
import { parseUpdateOrderParams } from 'api/helpers/account/order/parseUpdateOrderParams';
import { UpdateOrderParams } from 'api/types/params';

export const useUpdateOrder = () => {
  const notifyMessages = useNotifyMessages();

  const [handle, { loading, error: apolloError }] = useUpdateOrderMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    updateOrder: useCallback(
      async (id: string, versionNumber: number, params: UpdateOrderParams) => {
        const input = parseUpdateOrderParams(params);

        const res = await handle({
          variables: { id, input: { ...input, versionNumber } },
        });

        if (res.data?.updateOrder?.messages) {
          notifyMessages(res.data.updateOrder.messages);
        }

        return res.data?.updateOrder?.data
          ? parseOrderEntity(res.data.updateOrder.data)
          : null;
      },
      [handle, notifyMessages]
    ),
  };
};
